/**
 * Authentication Layout Component
 * Split-screen layout: 40% side panel, 60% form content
 * Per design guidelines: Side panel hidden on mobile (<1024px)
 */
import React, { type ReactNode } from 'react';
import { AuthSidePanel, type AuthSidePanelVariant } from './AuthSidePanel';

interface AuthLayoutProps {
  children: ReactNode;
  showSidePanel?: boolean;
  sidePanelVariant?: AuthSidePanelVariant;
}

export const AuthLayout = ({
  children,
  showSidePanel = false,
  sidePanelVariant = 'login',
}: AuthLayoutProps) => {
  return (
    <div className="flex min-h-screen" data-testid="auth-layout">
      {/* Side Panel (Desktop only) - 40% width */}
      {showSidePanel && (
        <div className="w-2/5">
          <AuthSidePanel variant={sidePanelVariant} />
        </div>
      )}

      {/* Main Content - 60% width or full width if no side panel */}
      <div
        className={`flex-1 flex items-center justify-center p-4 sm:p-6 lg:p-8 bg-slate-50`}
        data-testid="auth-content"
      >
        <div className="w-full max-w-md">{children}</div>
      </div>
    </div>
  );
};
